// extracted by mini-css-extract-plugin
export default {"icon":"IconButton_icon__oJoh3"};